import React from "react"

export default function Divider(props) {
  return pug`
    div.w-full.h-px.opacity-50.my-20(className=props.className?props.className:"bg-theme-300")
  `
}
